export default "__VITE_ASSET__D2ZOGa0I__"